import { gql } from 'apollo-angular';

export const CloneTacticDocument = gql/* GraphQL*/ `
  mutation cloneTactic($id: Int!) {
    cloneTactic(id: $id) {
      id
    }
  }
`;
